// extracted by mini-css-extract-plugin
export default {"wrap":"StudentsPage_wrap__GxRrJ","content":"StudentsPage_content__zs0XT","lists":"StudentsPage_lists__e-dDX"};